import React from 'react';
import { Link } from 'react-router-dom';
import { Quote, ArrowRight } from 'lucide-react';
import type { Story } from '../data/stories';
interface QuoteCardProps {
  story: Story;
}
export function QuoteCard({
  story
}: QuoteCardProps) {
  return <div className="border border-gray-200 rounded-lg p-6 bg-white" data-id="element-232">
      <Quote size={20} className="text-gray-300 mb-3" data-id="element-233" />
      <p className="text-gray-700 leading-relaxed mb-4 italic" data-id="element-234">
        "{story.quote}"
      </p>
      <div className="flex items-center justify-between" data-id="element-235">
        <div className="flex items-center" data-id="element-236">
          <div className="border border-dashed border-gray-300 w-10 h-10 rounded-full flex items-center justify-center bg-gray-100 mr-3 flex-shrink-0" data-id="element-237">
            <span className="text-gray-400 text-xs font-medium" data-id="element-238">
              {story.name.charAt(0)}
            </span>
          </div>
          <div data-id="element-239">
            <p className="text-sm font-medium text-gray-900" data-id="element-240">{story.name}</p>
            <p className="text-xs text-gray-500" data-id="element-241">{story.context}</p>
          </div>
        </div>
        {story.slug && <Link to={`/verhalen/${story.slug}`} className="text-xs font-medium text-gray-500 hover:text-gray-900 hover:underline inline-flex items-center flex-shrink-0 ml-4" data-id="element-242">
            Lees meer <ArrowRight size={12} className="ml-1" data-id="element-243" />
          </Link>}
      </div>
    </div>;
}